// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__aEktB","label":"CategoryService_label__wYlNm","location":"CategoryService_location__1zO6i"};